import React from 'react';

import { Navbar } from '../Home/Navbar';
import { Footer } from '../Home/Footer';
import { Level1 } from './Level1';





function Level1Layout() {
  return (
    <div>
     <Navbar/>
     <Level1/>
     <Footer/>
    </div>
  );
}

export default Level1Layout;
